import { render, staticRenderFns } from "./BrandDisplayView.vue?vue&type=template&id=9af6f828"
import script from "./BrandDisplayView.vue?vue&type=script&lang=js"
export * from "./BrandDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports